export default "__VITE_ASSET__DoccIQH1__"